import { Palmtree } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

type AvatarSize = "sm" | "md";

const SIZE: Record<AvatarSize, { avatar: string; fallback: string; dot: string; dotIcon: string }> =
  {
    sm: {
      avatar: "h-8 w-8",
      fallback: "text-[10px]",
      dot: "h-[15px] w-[15px]",
      dotIcon: "h-[8px] w-[8px]",
    },
    md: {
      avatar: "h-10 w-10",
      fallback: "text-xs",
      dot: "h-[18px] w-[18px]",
      dotIcon: "h-[10px] w-[10px]",
    },
  };

interface UserAvatarProps {
  initials: string;
  src?: string;
  isAusente: boolean;
  size?: AvatarSize;
  className?: string;
}

export function UserAvatar({ initials, src, isAusente, size = "sm", className }: UserAvatarProps) {
  const s = SIZE[size];

  return (
    <div className={cn("relative shrink-0", className)}>
      <div
        className={cn(
          "rounded-full",
          isAusente
            ? "outline outline-[3px] outline-offset-2 outline-amber-300 dark:outline-amber-600"
            : "",
        )}
      >
        <Avatar
          className={cn(
            s.avatar,
            "transition-all duration-200",
            isAusente ? "ring-0" : "ring-2 ring-border/50 group-hover:ring-primary/40",
          )}
        >
          <AvatarImage src={src} className="object-cover" />
          <AvatarFallback className={cn(s.fallback, "bg-primary/10 font-bold text-primary")}>
            {initials}
          </AvatarFallback>
        </Avatar>
      </div>

      {isAusente && (
        <span
          className={cn(
            "absolute -bottom-0.5 -right-0.5 flex items-center justify-center rounded-full",
            "border-2 border-background bg-amber-400 dark:bg-amber-500",
            s.dot,
          )}
        >
          <Palmtree className={cn("text-amber-900 dark:text-amber-950", s.dotIcon)} />
        </span>
      )}
    </div>
  );
}
